import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import CreditoCarbono from "./CreditoCarbono/CreditoCarbono";
import GeographicCoordinates from "./GeographicCoordinates/GeographicCoordinates";
import imageTopo from "../../assets/ods/topo.png";
import image01 from "../../assets/ods/erradicao-pobreza.png";
import image02 from "../../assets/ods/fome-zero.png";
import image03 from "../../assets/ods/saude-bem-estar.png";
import image04 from "../../assets/ods/educacao-qualidade.png";
import image05 from "../../assets/ods/igualdade-genero.png";
import image06 from "../../assets/ods/agua-potavel-saneamento.png";
import image07 from "../../assets/ods/energia-limpa.png";
import image08 from "../../assets/ods/trabalho-decente.png";
import image09 from "../../assets/ods/industria-inovacao.png";
import image10 from "../../assets/ods/reducao-desigualdade.png";
import image11 from "../../assets/ods/cidades-comunidades.png";
import image12 from "../../assets/ods/consumo-producao.png";
import image13 from "../../assets/ods/mudanca-do-clima.png";
import image14 from "../../assets/ods/vida-na-agua.png";
import image15 from "../../assets/ods/vida-terrestre.png";
import image16 from "../../assets/ods/paz-justica.png";
import image17 from "../../assets/ods/parcerias.png";
import image18 from "../../assets/ods/objetivos.png";
import CardButton from "./CardButton/CardButton";
import ProjectTokensRetirementList from "./ProjectTokensRetirementList/ProjectTokensRetirementList";
import ProjectTokensMonthlyViewList from "./ProjectTokensMonthlyViewList/ProjectTokensMonthlyViewList";
import ProjectTokensAnnualVisionList from "./ProjectTokensAnnualVisionList/ProjectTokensAnnualVisionList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHistory,
  faGlobe,
  faUser,
  faCalculator,
  faChartBar,
  faTable,
  faList,
  faUpload,
  faInfoCircle,
  faMoneyBill,
} from "@fortawesome/free-solid-svg-icons";
import {
  CardContainer,
  styles,
  WarningContainer,
  EngineeringRoot,
  EngineeringLoading,
  SubNav,
  SubNavGrid,
  SubNavItem,
  SubNavIcon,
  SubNavLabel,
  Panel,
  OdsSection,
  OdsBanner,
  OdsFooterImage,
} from "./styles";
import DocumentModelTopics from "../projects_t_engineering/FileUpload/documentModel/DocumentModelTopics";
import AdditionalInformation from "./AdditionalInformation/AdditionalInformation";
import ContasWilder from "./ContasWilder/ContasWilder";
import Moedas from "./CryptoMoeda/CryptoMoeda";
import { useLocation } from "react-router-dom";
import { WarningCard } from "./FileUpload/WarningCard/WarningCard";

const ProjectTabEngineering = ({ project }) => {
  const [telaAtiva, setTelaAtiva] = useState("cardsContainer");
  const documentModels = useSelector(
    (state) => state.documentModels?.models || []
  );
  const modeloEng = documentModels.find(
    (model) => model.nome === "Modelo Engenharia"
  );
  const engineering = useSelector((state) => state.app_data?.engineering || []);
  const matchObject = engineering.find((item) => item.project === project.id);

  let matchObjectId = null;
  const { state } = useLocation();
  const projetoId = state?.project?.id;

  const [isDocConfirmed, setDocConfirmed] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!modeloEng) {
    return (
      <EngineeringLoading>Carregando modelo Engenharia...</EngineeringLoading>
    );
  }

  const menuItems = [
    {
      id: "cardsContainer",
      icon: faUser,
      color: "var(--success)",
      label: "Objetivos Desenv. Sust.",
      shortLabel: "ODS",
    },
    {
      id: "geographicCoordinates",
      icon: faGlobe,
      color: "red",
      label: "Coordenada Geográfica",
      shortLabel: "Coordenadas",
    },
    {
      id: "additionalInformation",
      icon: faInfoCircle,
      color: "orange",
      label: "Informações PDD",
      shortLabel: "PDD",
    },
    {
      id: "creditoCarbono",
      icon: faCalculator,
      color: "blue",
      label: "Crédito de Carbono",
      shortLabel: "Carbono",
    },
    {
      id: "projectTokensMonthlyViewList",
      icon: faChartBar,
      color: "purple",
      label: "Tokens Visão Mensal",
      shortLabel: "Tokens mês",
    },
    {
      id: "projectTokensAnnualVisionList",
      icon: faTable,
      color: "orange",
      label: "Tokens Visão Anual",
      shortLabel: "Tokens ano",
    },
    {
      id: "projectTokensRetirementList",
      icon: faList,
      color: "brown",
      label: "Tokens Aposentadoria",
      shortLabel: "Aposentadoria",
    },
    {
      id: "uploadsSave",
      icon: faUpload,
      color: "gold",
      label: "Gerenciar Projeto",
      shortLabel: "Gerenciar",
    },
    {
      id: "Rastreality",
      icon: faHistory,
      color: "var(--success)",
      label: "Contas Wilder",
      shortLabel: "Wilder",
    },
    {
      id: "Moedas",
      icon: faMoneyBill,
      color: "var(--success)",
      label: "Vert Carbon Credit",
      shortLabel: "VCC",
    },
  ];

  if (projetoId) {
    matchObjectId = projetoId;
  } else if (matchObject?.id) {
    matchObjectId = matchObject.id;
  } else if (project?.id) {
    matchObjectId = project.id;
  }

  const renderizarTela = () => {
    switch (telaAtiva) {
      case "cardsContainer":
        return (
          <OdsSection>
            <OdsBanner>
              <img src={imageTopo} alt="Objetivos de Desenvolvimento Sustentável" />
            </OdsBanner>
            <CardContainer>
              <CardButton
                image={image01}
                project_id={project.id}
                card_name={"erradicao-pobreza"}
              />
              <CardButton
                image={image02}
                project_id={project.id}
                card_name={"fome-zero"}
              />
              <CardButton
                image={image03}
                project_id={project.id}
                card_name={"saude-bem-estar"}
              />
              <CardButton
                image={image04}
                project_id={project.id}
                card_name={"educacao-qualidade"}
              />
              <CardButton
                image={image05}
                project_id={project.id}
                card_name={"igualdade-genero"}
              />
              <CardButton
                image={image06}
                project_id={project.id}
                card_name={"agua-potavel-saneamento"}
              />
              <CardButton
                image={image07}
                project_id={project.id}
                card_name={"energia-limpa"}
              />
              <CardButton
                image={image08}
                project_id={project.id}
                card_name={"trabalho-decente"}
              />
              <CardButton
                image={image09}
                project_id={project.id}
                card_name={"industria-inovacao"}
              />
              <CardButton
                image={image10}
                project_id={project.id}
                card_name={"reducao-desigualdade"}
              />
              <CardButton
                image={image11}
                project_id={project.id}
                card_name={"cidades-comunidades"}
              />
              <CardButton
                image={image12}
                project_id={project.id}
                card_name={"consumo-producao"}
              />
              <CardButton
                image={image13}
                project_id={project.id}
                card_name={"mudanca-do-clima"}
              />
              <CardButton
                image={image14}
                project_id={project.id}
                card_name={"vida-na-agua"}
              />
              <CardButton
                image={image15}
                project_id={project.id}
                card_name={"vida-terrestre"}
              />
              <CardButton
                image={image16}
                project_id={project.id}
                card_name={"paz-justica"}
              />
              <CardButton
                image={image17}
                project_id={project.id}
                card_name={"parcerias"}
              />
              <OdsFooterImage src={image18} alt="Objetivos" />
            </CardContainer>
          </OdsSection>
        );
      case "geographicCoordinates":
        return (
          <div style={styles.pagina}>
            <GeographicCoordinates project_id={project.id} />
          </div>
        );
      case "additionalInformation":
        return (
          <div style={styles.pagina}>
            <AdditionalInformation
              project_id={project.id}
              matchObjectId={matchObjectId}
            />
          </div>
        );
      case "creditoCarbono":
        return (
          <div style={styles.pagina}>
            <CreditoCarbono project_id={project.id} />
          </div>
        );
      case "projectTokensMonthlyViewList":
        return (
          <div style={styles.pagina}>
            <ProjectTokensMonthlyViewList project_id={project.id} />
          </div>
        );
      case "projectTokensAnnualVisionList":
        return (
          <div style={styles.pagina}>
            <ProjectTokensAnnualVisionList project_id={project.id} />
          </div>
        );
      case "projectTokensRetirementList":
        return (
          <div style={styles.pagina}>
            <ProjectTokensRetirementList project_id={project.id} />
          </div>
        );
      case "uploadsSave":
        return (
          <div style={styles.pagina}>
            {!isDocConfirmed && (
              <WarningContainer>
                <WarningCard />
              </WarningContainer>
            )}

            <DocumentModelTopics
              projectId={project.id}
              modeloId={modeloEng.id}
              telaName="Gerenciar Projeto"
              onDocumentsConfirmed={setDocConfirmed}
            />
          </div>
        );
      case "Rastreality":
        return (
          <div style={styles.pagina}>
            <ContasWilder />
          </div>
        );
      case "Moedas":
        return (
          <div style={styles.pagina}>
            <Moedas />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <EngineeringRoot>
      <SubNav aria-label="Seções da aba Ambiental">
        <SubNavGrid>
          {menuItems.map(({ id, icon, color, label, shortLabel }) => {
            const active = telaAtiva === id;
            return (
              <SubNavItem
                key={id}
                type="button"
                $active={active}
                onClick={() => setTelaAtiva(id)}
                title={label}
                aria-current={active ? "page" : undefined}
              >
                <SubNavIcon $active={active} $color={color}>
                  <FontAwesomeIcon icon={icon} />
                </SubNavIcon>
                <SubNavLabel className="subnav-label-full">{label}</SubNavLabel>
                <SubNavLabel className="subnav-label-short">
                  {shortLabel}
                </SubNavLabel>
              </SubNavItem>
            );
          })}
        </SubNavGrid>
      </SubNav>
      <Panel>{renderizarTela()}</Panel>
    </EngineeringRoot>
  );
};

export default ProjectTabEngineering;
